module.exports = __webpack_public_path__ + "static/media/pipeten_active_handschuhe_true_arbeitsmittel_true.65af24fe.jpg";